import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal, Overlay, ScrollArea } from '@mantine/core';

import { useAddBotPage } from '../../api/addPage';
import { botTypes } from '../../types';

import { PageForm } from './PageForm';

export const AddModal = NiceModal.create(
  ({ page }: { page: Omit<botTypes.Page, '_id' | 'subDepartment'> }) => {
    const modal = useModal();

    const addPage = useAddBotPage({ config: { onSuccess: modal.hide } });

    return (
      <Modal
        title="New page"
        centered
        overlayProps={{ opacity: 0.4, blur: 1.5 }}
        opened={modal.visible}
        onClose={modal.remove}
        closeOnEscape={!addPage.isLoading}
        closeOnClickOutside={!addPage.isLoading}
        withCloseButton={!addPage.isLoading}
        scrollAreaComponent={ScrollArea.Autosize}
      >
        {addPage.isLoading && <Overlay opacity={0} />}
        <PageForm
          onSubmit={(data) => addPage.mutate({ ...data })}
          isLoading={addPage.isLoading}
          initialValues={{
            name: page.name,
            externalId: page.externalId,
            department: page.department,
            appPages: page.appPages,
          }}
        />
      </Modal>
    );
  }
);
